import React, { memo, useMemo } from "react";
import { Blok } from "../../interfaces/Blok.interface";
import StructuredData from "../StructuredData/StructuredData";

interface LocationAddressStructuredDataBlokProps extends Blok {
  street_address: string;
  address_locality: string;
  address_region: string;
  postal_code: string;
  address_country: string;
}

interface LocationAddressStructuredDataProps {
  blok: LocationAddressStructuredDataBlokProps;
}

const LocationAddressStructuredData: React.FC<
  LocationAddressStructuredDataProps
> = ({ blok }) => {
  const {
    street_address,
    address_locality,
    address_region,
    postal_code,
    address_country
  } = blok;

  const locationAddressStructuredData = useMemo(() => {
    return {
      "@type": "Organization",
      address: {
        "@type": "PostalAddress",
        streetAddress: street_address,
        addressLocality: address_locality,
        addressRegion: address_region,
        postalCode: postal_code,
        addressCountry: address_country
      }
    };
  }, [blok]);

  return <StructuredData>{locationAddressStructuredData}</StructuredData>;
};

export default memo(LocationAddressStructuredData);
